'use client';

import { slugify } from '@/lib/shared/utils/slugify';
import Link from 'next/link';
import * as React from 'react';
import { X } from 'lucide-react';
import { H3 } from '@/components/ui/typography';
import { cn } from '@/lib/shared/ui';
import { tagName } from '@/lib/shared/utils/cookbook';
import { Button } from '@/components/ui/button';

type Props = {
  tags: Array<{
    name: string;
    count: number;
  }>;
  selectedTag?: string;
};

export default function TagsFilter(props: Props) {
  const { tags, selectedTag } = props;
  const [expandedOnMobile, setExpandedOnMobile] = React.useState(false);

  return (
    <div className="flex flex-col gap-10">
      <div className="flex justify-between">
        <H3>Filter by Tags</H3>
        <div className="md:hidden">
          <button
            onClick={() => setExpandedOnMobile(!expandedOnMobile)}
            className="hover:underline"
          >
            {expandedOnMobile ? 'Hide Tags' : 'Show Tags'}
          </button>
        </div>
      </div>

      <div className={cn('flex flex-col gap-4 md:flex', !expandedOnMobile && 'hidden')}>
        {tags.map((tag) => (
          <div key={tag.name} className="flex items-center justify-between">
            <Link
              href={`/cookbook/tag/${slugify(tag.name)}/#articles`}
              className="flex justify-between items-center flex-1"
              data-testid={`cookbook-tag-link-${slugify(tag.name)}`}
            >
              <div>{tagName(tag.name)}</div>
              {selectedTag !== tag.name && <div className="opacity-70">{tag.count}</div>}
            </Link>

            {selectedTag === tag.name && (
              <Link href="/cookbook/#articles">
                <Button variant="ghost" size="icon" className="opacity-70 w-5 h-5 [&_svg]:size-4">
                  <X className="text-negative" />
                </Button>
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
